<app-dialog class="efficiency-analysis-config-dialog">
  <ng-container dialog-title>
    {{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.title' | translate }}
  </ng-container>

  <ng-container dialog-content>
    <mat-tab-group [(selectedIndex)]="tabIndex" [animationDuration]="0" [disableRipple]="true">
      <mat-tab>
        <ng-template mat-tab-label>
          <div>
            <span class="tab-text">{{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.objectTypeTabText' | translate }}</span>
          </div>
        </ng-template>
        <ng-template matTabContent>
          <div class="tab-content">
            <app-modify-reference-values (closeEvent)="close()" (isRecalculated)="isRecalculated($event)"></app-modify-reference-values>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <div>
            <span class="tab-text">{{ 'module.efficiencyAnalysis.efficiencyAnalysisConfigDialog.generalTabText' | translate }}</span>
          </div>
        </ng-template>
        <ng-template matTabContent>
          <div class="tab-content">
            <app-modify-efficiency-treshold (closeEvent)="close()"></app-modify-efficiency-treshold>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
</app-dialog>
